// source: student.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var enum_pb = require('./enum_pb.js');

goog.object.extend(proto, enum_pb);

var courses_pb = require('./courses_pb.js');

goog.object.extend(proto, courses_pb);

var schools_pb = require('./schools_pb.js');

goog.object.extend(proto, schools_pb);

var user_pb = require('./user_pb.js');

goog.object.extend(proto, user_pb);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');

goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.manabie.bob.ApplyActivationCodeRequest', null, global);
goog.exportSymbol('proto.manabie.bob.ApplyActivationCodeResponse', null, global);
goog.exportSymbol('proto.manabie.bob.ArchivedTopic', null, global);
goog.exportSymbol('proto.manabie.bob.ArchivedTopic.Status', null, global);
goog.exportSymbol('proto.manabie.bob.AssignPresetStudyPlansRequest', null, global);
goog.exportSymbol('proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail', null, global);
goog.exportSymbol('proto.manabie.bob.AssignPresetStudyPlansResponse', null, global);
goog.exportSymbol('proto.manabie.bob.AssignToCoachRequest', null, global);
goog.exportSymbol('proto.manabie.bob.AssignToCoachResponse', null, global);
goog.exportSymbol('proto.manabie.bob.BillingHistory', null, global);
goog.exportSymbol('proto.manabie.bob.CommentInfo', null, global);
goog.exportSymbol('proto.manabie.bob.CountTotalLOsFinishedRequest', null, global);
goog.exportSymbol('proto.manabie.bob.CountTotalLOsFinishedResponse', null, global);
goog.exportSymbol('proto.manabie.bob.FindStudentRequest', null, global);
goog.exportSymbol('proto.manabie.bob.FindStudentResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetStudentProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetStudentProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetStudentProfileResponse.Data', null, global);
goog.exportSymbol('proto.manabie.bob.Permission', null, global);
goog.exportSymbol('proto.manabie.bob.PermissionAllowGrade', null, global);
goog.exportSymbol('proto.manabie.bob.RegisterRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RegisterResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RenewStudentBillingDateRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RenewStudentBillingDateResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveArchivedTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveArchivedTopicsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveDailyLOFinishedRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveDailyLOFinishedResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveLearningProgressRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveLearningProgressResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveOverdueTopicRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveOverdueTopicResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePresetStudyPlansRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrievePresetStudyPlansResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentBillingHistoryRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentBillingHistoryResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentCommentRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentCommentResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStatRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStatResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlansRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlansResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudyAheadTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveStudyAheadTopicsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveTotalLOsFinishedRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveTotalLOsFinishedResponse', null, global);
goog.exportSymbol('proto.manabie.bob.StudentComment', null, global);
goog.exportSymbol('proto.manabie.bob.StudentEventLog', null, global);
goog.exportSymbol('proto.manabie.bob.StudentEventLogRequest', null, global);
goog.exportSymbol('proto.manabie.bob.StudentEventLogResponse', null, global);
goog.exportSymbol('proto.manabie.bob.StudentPermissionRequest', null, global);
goog.exportSymbol('proto.manabie.bob.StudentPermissionResponse', null, global);
goog.exportSymbol('proto.manabie.bob.StudentProfile', null, global);
goog.exportSymbol('proto.manabie.bob.StudentStat', null, global);
goog.exportSymbol('proto.manabie.bob.StudyAheadTopic', null, global);
goog.exportSymbol('proto.manabie.bob.TopicOverdue', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateProfileRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpdateProfileResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertStudentCommentRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertStudentCommentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.manabie.bob.RegisterRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RegisterRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RegisterRequest.displayName = 'proto.manabie.bob.RegisterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RegisterResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RegisterResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RegisterResponse.displayName = 'proto.manabie.bob.RegisterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetStudentProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetStudentProfileRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetStudentProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetStudentProfileRequest.displayName = 'proto.manabie.bob.GetStudentProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentProfile = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentProfile, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentProfile.displayName = 'proto.manabie.bob.StudentProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetStudentProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetStudentProfileResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetStudentProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetStudentProfileResponse.displayName = 'proto.manabie.bob.GetStudentProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetStudentProfileResponse.Data = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetStudentProfileResponse.Data, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetStudentProfileResponse.Data.displayName = 'proto.manabie.bob.GetStudentProfileResponse.Data';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateProfileRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateProfileRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateProfileRequest.displayName = 'proto.manabie.bob.UpdateProfileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpdateProfileResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpdateProfileResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpdateProfileResponse.displayName = 'proto.manabie.bob.UpdateProfileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveLearningProgressRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveLearningProgressRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveLearningProgressRequest.displayName = 'proto.manabie.bob.RetrieveLearningProgressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveLearningProgressResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveLearningProgressResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveLearningProgressResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveLearningProgressResponse.displayName = 'proto.manabie.bob.RetrieveLearningProgressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.displayName = 'proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentEventLog = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentEventLog, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentEventLog.displayName = 'proto.manabie.bob.StudentEventLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentEventLogRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.StudentEventLogRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.StudentEventLogRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentEventLogRequest.displayName = 'proto.manabie.bob.StudentEventLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentComment = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentComment, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentComment.displayName = 'proto.manabie.bob.StudentComment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentEventLogResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentEventLogResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentEventLogResponse.displayName = 'proto.manabie.bob.StudentEventLogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.AssignToCoachRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.AssignToCoachRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.AssignToCoachRequest.displayName = 'proto.manabie.bob.AssignToCoachRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.AssignToCoachResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.AssignToCoachResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.AssignToCoachResponse.displayName = 'proto.manabie.bob.AssignToCoachResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrievePresetStudyPlansRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePresetStudyPlansRequest.displayName = 'proto.manabie.bob.RetrievePresetStudyPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrievePresetStudyPlansResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrievePresetStudyPlansResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePresetStudyPlansResponse.displayName = 'proto.manabie.bob.RetrievePresetStudyPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.displayName = 'proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.displayName = 'proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.AssignPresetStudyPlansRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.AssignPresetStudyPlansRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.AssignPresetStudyPlansRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.AssignPresetStudyPlansRequest.displayName = 'proto.manabie.bob.AssignPresetStudyPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.displayName = 'proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.AssignPresetStudyPlansResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.AssignPresetStudyPlansResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.AssignPresetStudyPlansResponse.displayName = 'proto.manabie.bob.AssignPresetStudyPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlansRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlansRequest.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveStudentStudyPlansResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlansResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.displayName = 'proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentStat = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentStat, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentStat.displayName = 'proto.manabie.bob.StudentStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStatRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStatRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStatRequest.displayName = 'proto.manabie.bob.RetrieveStudentStatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentStatResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentStatResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentStatResponse.displayName = 'proto.manabie.bob.RetrieveStudentStatResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RenewStudentBillingDateRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RenewStudentBillingDateRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RenewStudentBillingDateRequest.displayName = 'proto.manabie.bob.RenewStudentBillingDateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.BillingHistory = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.BillingHistory, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.BillingHistory.displayName = 'proto.manabie.bob.BillingHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RenewStudentBillingDateResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RenewStudentBillingDateResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RenewStudentBillingDateResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RenewStudentBillingDateResponse.displayName = 'proto.manabie.bob.RenewStudentBillingDateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentBillingHistoryRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentBillingHistoryRequest.displayName = 'proto.manabie.bob.RetrieveStudentBillingHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveStudentBillingHistoryResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentBillingHistoryResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentBillingHistoryResponse.displayName = 'proto.manabie.bob.RetrieveStudentBillingHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.FindStudentRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.FindStudentRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.FindStudentRequest.displayName = 'proto.manabie.bob.FindStudentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.FindStudentResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.FindStudentResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.FindStudentResponse.displayName = 'proto.manabie.bob.FindStudentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertStudentCommentRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpsertStudentCommentRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertStudentCommentRequest.displayName = 'proto.manabie.bob.UpsertStudentCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertStudentCommentResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpsertStudentCommentResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertStudentCommentResponse.displayName = 'proto.manabie.bob.UpsertStudentCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentCommentRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentCommentRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentCommentRequest.displayName = 'proto.manabie.bob.RetrieveStudentCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CommentInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CommentInfo, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CommentInfo.displayName = 'proto.manabie.bob.CommentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudentCommentResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveStudentCommentResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudentCommentResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudentCommentResponse.displayName = 'proto.manabie.bob.RetrieveStudentCommentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveDailyLOFinishedRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveDailyLOFinishedRequest.displayName = 'proto.manabie.bob.RetrieveDailyLOFinishedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveDailyLOFinishedResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveDailyLOFinishedResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.displayName = 'proto.manabie.bob.RetrieveDailyLOFinishedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.displayName = 'proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudyAheadTopic = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudyAheadTopic, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudyAheadTopic.displayName = 'proto.manabie.bob.StudyAheadTopic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudyAheadTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudyAheadTopicsRequest.displayName = 'proto.manabie.bob.RetrieveStudyAheadTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveStudyAheadTopicsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveStudyAheadTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveStudyAheadTopicsResponse.displayName = 'proto.manabie.bob.RetrieveStudyAheadTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveTotalLOsFinishedRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveTotalLOsFinishedRequest.displayName = 'proto.manabie.bob.RetrieveTotalLOsFinishedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveTotalLOsFinishedResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveTotalLOsFinishedResponse.displayName = 'proto.manabie.bob.RetrieveTotalLOsFinishedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CountTotalLOsFinishedRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CountTotalLOsFinishedRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CountTotalLOsFinishedRequest.displayName = 'proto.manabie.bob.CountTotalLOsFinishedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.CountTotalLOsFinishedResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.CountTotalLOsFinishedResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.CountTotalLOsFinishedResponse.displayName = 'proto.manabie.bob.CountTotalLOsFinishedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveArchivedTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveArchivedTopicsRequest.displayName = 'proto.manabie.bob.RetrieveArchivedTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ArchivedTopic = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ArchivedTopic, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ArchivedTopic.displayName = 'proto.manabie.bob.ArchivedTopic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveArchivedTopicsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveArchivedTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveArchivedTopicsResponse.displayName = 'proto.manabie.bob.RetrieveArchivedTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentPermissionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentPermissionRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentPermissionRequest.displayName = 'proto.manabie.bob.StudentPermissionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PermissionAllowGrade = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.PermissionAllowGrade.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.PermissionAllowGrade, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PermissionAllowGrade.displayName = 'proto.manabie.bob.PermissionAllowGrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Permission = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Permission.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Permission, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Permission.displayName = 'proto.manabie.bob.Permission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.StudentPermissionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.StudentPermissionResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.StudentPermissionResponse.displayName = 'proto.manabie.bob.StudentPermissionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ApplyActivationCodeRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ApplyActivationCodeRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ApplyActivationCodeRequest.displayName = 'proto.manabie.bob.ApplyActivationCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ApplyActivationCodeResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ApplyActivationCodeResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ApplyActivationCodeResponse.displayName = 'proto.manabie.bob.ApplyActivationCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.TopicOverdue = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.TopicOverdue, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.TopicOverdue.displayName = 'proto.manabie.bob.TopicOverdue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveOverdueTopicRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveOverdueTopicRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveOverdueTopicRequest.displayName = 'proto.manabie.bob.RetrieveOverdueTopicRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveOverdueTopicResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveOverdueTopicResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveOverdueTopicResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveOverdueTopicResponse.displayName = 'proto.manabie.bob.RetrieveOverdueTopicResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.displayName = 'proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.displayName = 'proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.displayName = 'proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RegisterRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RegisterRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RegisterRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RegisterRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      country: jspb.Message.getFieldWithDefault(msg, 2, 0),
      phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
      email: jspb.Message.getFieldWithDefault(msg, 4, ""),
      grade: jspb.Message.getFieldWithDefault(msg, 5, ""),
      targetUniversity: jspb.Message.getFieldWithDefault(msg, 6, ""),
      school: (f = msg.getSchool()) && schools_pb.School.toObject(includeInstance, f),
      activationCode: jspb.Message.getFieldWithDefault(msg, 8, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RegisterRequest}
 */


proto.manabie.bob.RegisterRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RegisterRequest();
  return proto.manabie.bob.RegisterRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RegisterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RegisterRequest}
 */


proto.manabie.bob.RegisterRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhone(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmail(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetUniversity(value);
        break;

      case 7:
        var value = new schools_pb.School();
        reader.readMessage(value, schools_pb.School.deserializeBinaryFromReader);
        msg.setSchool(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setActivationCode(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RegisterRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RegisterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RegisterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RegisterRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }

  f = message.getPhone();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getEmail();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getTargetUniversity();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getSchool();

  if (f != null) {
    writer.writeMessage(7, f, schools_pb.School.serializeBinaryToWriter);
  }

  f = message.getActivationCode();

  if (f.length > 0) {
    writer.writeString(8, f);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Country country = 2;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.RegisterRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.RegisterRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string phone = 3;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getPhone = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setPhone = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string email = 4;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setEmail = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string grade = 5;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string target_university = 6;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getTargetUniversity = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setTargetUniversity = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional School school = 7;
 * @return {?proto.manabie.bob.School}
 */


proto.manabie.bob.RegisterRequest.prototype.getSchool = function () {
  return (
    /** @type{?proto.manabie.bob.School} */
    jspb.Message.getWrapperField(this, schools_pb.School, 7)
  );
};
/** @param {?proto.manabie.bob.School|undefined} value */


proto.manabie.bob.RegisterRequest.prototype.setSchool = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RegisterRequest.prototype.clearSchool = function () {
  this.setSchool(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RegisterRequest.prototype.hasSchool = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional string activation_code = 8;
 * @return {string}
 */


proto.manabie.bob.RegisterRequest.prototype.getActivationCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RegisterRequest.prototype.setActivationCode = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RegisterResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RegisterResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RegisterResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RegisterResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      onTrial: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
      billingDate: (f = msg.getBillingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RegisterResponse}
 */


proto.manabie.bob.RegisterResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RegisterResponse();
  return proto.manabie.bob.RegisterResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RegisterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RegisterResponse}
 */


proto.manabie.bob.RegisterResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      case 2:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setOnTrial(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setBillingDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RegisterResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RegisterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RegisterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RegisterResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }

  f = message.getOnTrial();

  if (f) {
    writer.writeBool(2, f);
  }

  f = message.getBillingDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.RegisterResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.RegisterResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional bool on_trial = 2;
 * @return {boolean}
 */


proto.manabie.bob.RegisterResponse.prototype.getOnTrial = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 2, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.RegisterResponse.prototype.setOnTrial = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp billing_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RegisterResponse.prototype.getBillingDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RegisterResponse.prototype.setBillingDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RegisterResponse.prototype.clearBillingDate = function () {
  this.setBillingDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RegisterResponse.prototype.hasBillingDate = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetStudentProfileRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetStudentProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetStudentProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetStudentProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetStudentProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetStudentProfileRequest}
 */


proto.manabie.bob.GetStudentProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetStudentProfileRequest();
  return proto.manabie.bob.GetStudentProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetStudentProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetStudentProfileRequest}
 */


proto.manabie.bob.GetStudentProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addStudentIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetStudentProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetStudentProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetStudentProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetStudentProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string student_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.GetStudentProfileRequest.prototype.getStudentIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.GetStudentProfileRequest.prototype.setStudentIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.GetStudentProfileRequest.prototype.addStudentIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetStudentProfileRequest.prototype.clearStudentIdsList = function () {
  this.setStudentIdsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentProfile.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentProfile.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentProfile} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentProfile.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      phone: jspb.Message.getFieldWithDefault(msg, 4, ""),
      email: jspb.Message.getFieldWithDefault(msg, 5, ""),
      grade: jspb.Message.getFieldWithDefault(msg, 6, ""),
      targetUniversity: jspb.Message.getFieldWithDefault(msg, 7, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 8, ""),
      birthday: (f = msg.getBirthday()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      biography: jspb.Message.getFieldWithDefault(msg, 10, ""),
      paymentStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
      billingDate: (f = msg.getBillingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      school: (f = msg.getSchool()) && schools_pb.School.toObject(includeInstance, f),
      planId: jspb.Message.getFieldWithDefault(msg, 15, ""),
      billingAt: (f = msg.getBillingAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      isTester: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
      facebookId: jspb.Message.getFieldWithDefault(msg, 18, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentProfile}
 */


proto.manabie.bob.StudentProfile.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentProfile();
  return proto.manabie.bob.StudentProfile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentProfile}
 */


proto.manabie.bob.StudentProfile.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhone(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEmail(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetUniversity(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 9:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setBirthday(value);
        break;

      case 10:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBiography(value);
        break;

      case 11:
        var value =
        /** @type {!proto.manabie.bob.PaymentStatus} */
        reader.readEnum();
        msg.setPaymentStatus(value);
        break;

      case 12:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setBillingDate(value);
        break;

      case 13:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 14:
        var value = new schools_pb.School();
        reader.readMessage(value, schools_pb.School.deserializeBinaryFromReader);
        msg.setSchool(value);
        break;

      case 15:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlanId(value);
        break;

      case 16:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setBillingAt(value);
        break;

      case 17:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsTester(value);
        break;

      case 18:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFacebookId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentProfile.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentProfile.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getPhone();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getEmail();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getTargetUniversity();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getBirthday();

  if (f != null) {
    writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getBiography();

  if (f.length > 0) {
    writer.writeString(10, f);
  }

  f = message.getPaymentStatus();

  if (f !== 0.0) {
    writer.writeEnum(11, f);
  }

  f = message.getBillingDate();

  if (f != null) {
    writer.writeMessage(12, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(13, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getSchool();

  if (f != null) {
    writer.writeMessage(14, f, schools_pb.School.serializeBinaryToWriter);
  }

  f = message.getPlanId();

  if (f.length > 0) {
    writer.writeString(15, f);
  }

  f = message.getBillingAt();

  if (f != null) {
    writer.writeMessage(16, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getIsTester();

  if (f) {
    writer.writeBool(17, f);
  }

  f = message.getFacebookId();

  if (f.length > 0) {
    writer.writeString(18, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.StudentProfile.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.StudentProfile.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string phone = 4;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getPhone = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setPhone = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string email = 5;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setEmail = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string grade = 6;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string target_university = 7;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getTargetUniversity = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setTargetUniversity = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string avatar = 8;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional google.protobuf.Timestamp birthday = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentProfile.prototype.getBirthday = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentProfile.prototype.setBirthday = function (value) {
  jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentProfile.prototype.clearBirthday = function () {
  this.setBirthday(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.hasBirthday = function () {
  return jspb.Message.getField(this, 9) != null;
};
/**
 * optional string biography = 10;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getBiography = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 10, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setBiography = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional PaymentStatus payment_status = 11;
 * @return {!proto.manabie.bob.PaymentStatus}
 */


proto.manabie.bob.StudentProfile.prototype.getPaymentStatus = function () {
  return (
    /** @type {!proto.manabie.bob.PaymentStatus} */
    jspb.Message.getFieldWithDefault(this, 11, 0)
  );
};
/** @param {!proto.manabie.bob.PaymentStatus} value */


proto.manabie.bob.StudentProfile.prototype.setPaymentStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};
/**
 * optional google.protobuf.Timestamp billing_date = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentProfile.prototype.getBillingDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentProfile.prototype.setBillingDate = function (value) {
  jspb.Message.setWrapperField(this, 12, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentProfile.prototype.clearBillingDate = function () {
  this.setBillingDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.hasBillingDate = function () {
  return jspb.Message.getField(this, 12) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentProfile.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentProfile.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 13, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentProfile.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 13) != null;
};
/**
 * optional School school = 14;
 * @return {?proto.manabie.bob.School}
 */


proto.manabie.bob.StudentProfile.prototype.getSchool = function () {
  return (
    /** @type{?proto.manabie.bob.School} */
    jspb.Message.getWrapperField(this, schools_pb.School, 14)
  );
};
/** @param {?proto.manabie.bob.School|undefined} value */


proto.manabie.bob.StudentProfile.prototype.setSchool = function (value) {
  jspb.Message.setWrapperField(this, 14, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentProfile.prototype.clearSchool = function () {
  this.setSchool(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.hasSchool = function () {
  return jspb.Message.getField(this, 14) != null;
};
/**
 * optional string plan_id = 15;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 15, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};
/**
 * optional google.protobuf.Timestamp billing_at = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentProfile.prototype.getBillingAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentProfile.prototype.setBillingAt = function (value) {
  jspb.Message.setWrapperField(this, 16, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentProfile.prototype.clearBillingAt = function () {
  this.setBillingAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.hasBillingAt = function () {
  return jspb.Message.getField(this, 16) != null;
};
/**
 * optional bool is_tester = 17;
 * @return {boolean}
 */


proto.manabie.bob.StudentProfile.prototype.getIsTester = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 17, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.StudentProfile.prototype.setIsTester = function (value) {
  jspb.Message.setProto3BooleanField(this, 17, value);
};
/**
 * optional string facebook_id = 18;
 * @return {string}
 */


proto.manabie.bob.StudentProfile.prototype.getFacebookId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 18, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentProfile.prototype.setFacebookId = function (value) {
  jspb.Message.setProto3StringField(this, 18, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetStudentProfileResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetStudentProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetStudentProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetStudentProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetStudentProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      datasList: jspb.Message.toObjectList(msg.getDatasList(), proto.manabie.bob.GetStudentProfileResponse.Data.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetStudentProfileResponse}
 */


proto.manabie.bob.GetStudentProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetStudentProfileResponse();
  return proto.manabie.bob.GetStudentProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetStudentProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetStudentProfileResponse}
 */


proto.manabie.bob.GetStudentProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.GetStudentProfileResponse.Data();
        reader.readMessage(value, proto.manabie.bob.GetStudentProfileResponse.Data.deserializeBinaryFromReader);
        msg.addDatas(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetStudentProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetStudentProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetStudentProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetStudentProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDatasList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.GetStudentProfileResponse.Data.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetStudentProfileResponse.Data.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetStudentProfileResponse.Data.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetStudentProfileResponse.Data} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetStudentProfileResponse.Data.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profile: (f = msg.getProfile()) && proto.manabie.bob.StudentProfile.toObject(includeInstance, f),
      coachId: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetStudentProfileResponse.Data}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetStudentProfileResponse.Data();
  return proto.manabie.bob.GetStudentProfileResponse.Data.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetStudentProfileResponse.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetStudentProfileResponse.Data}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentProfile();
        reader.readMessage(value, proto.manabie.bob.StudentProfile.deserializeBinaryFromReader);
        msg.setProfile(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCoachId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetStudentProfileResponse.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetStudentProfileResponse.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetStudentProfileResponse.Data.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfile();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.StudentProfile.serializeBinaryToWriter);
  }

  f = message.getCoachId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional StudentProfile profile = 1;
 * @return {?proto.manabie.bob.StudentProfile}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.getProfile = function () {
  return (
    /** @type{?proto.manabie.bob.StudentProfile} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.StudentProfile, 1)
  );
};
/** @param {?proto.manabie.bob.StudentProfile|undefined} value */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.setProfile = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.clearProfile = function () {
  this.setProfile(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.hasProfile = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional string coach_id = 2;
 * @return {string}
 */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.getCoachId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetStudentProfileResponse.Data.prototype.setCoachId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated Data datas = 1;
 * @return {!Array<!proto.manabie.bob.GetStudentProfileResponse.Data>}
 */


proto.manabie.bob.GetStudentProfileResponse.prototype.getDatasList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.GetStudentProfileResponse.Data>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.GetStudentProfileResponse.Data, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.GetStudentProfileResponse.Data>} value */


proto.manabie.bob.GetStudentProfileResponse.prototype.setDatasList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.GetStudentProfileResponse.Data=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.GetStudentProfileResponse.Data}
 */


proto.manabie.bob.GetStudentProfileResponse.prototype.addDatas = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.GetStudentProfileResponse.Data, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetStudentProfileResponse.prototype.clearDatasList = function () {
  this.setDatasList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateProfileRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateProfileRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateProfileRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateProfileRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      grade: jspb.Message.getFieldWithDefault(msg, 2, ""),
      targetUniversity: jspb.Message.getFieldWithDefault(msg, 3, ""),
      avatar: jspb.Message.getFieldWithDefault(msg, 4, ""),
      birthday: (f = msg.getBirthday()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      biography: jspb.Message.getFieldWithDefault(msg, 6, ""),
      school: (f = msg.getSchool()) && schools_pb.School.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateProfileRequest}
 */


proto.manabie.bob.UpdateProfileRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateProfileRequest();
  return proto.manabie.bob.UpdateProfileRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateProfileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateProfileRequest}
 */


proto.manabie.bob.UpdateProfileRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTargetUniversity(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAvatar(value);
        break;

      case 5:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setBirthday(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBiography(value);
        break;

      case 7:
        var value = new schools_pb.School();
        reader.readMessage(value, schools_pb.School.deserializeBinaryFromReader);
        msg.setSchool(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateProfileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateProfileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateProfileRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getTargetUniversity();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getAvatar();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getBirthday();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getBiography();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getSchool();

  if (f != null) {
    writer.writeMessage(7, f, schools_pb.School.serializeBinaryToWriter);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string grade = 2;
 * @return {string}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string target_university = 3;
 * @return {string}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getTargetUniversity = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setTargetUniversity = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string avatar = 4;
 * @return {string}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getAvatar = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setAvatar = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional google.protobuf.Timestamp birthday = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getBirthday = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setBirthday = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UpdateProfileRequest.prototype.clearBirthday = function () {
  this.setBirthday(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.hasBirthday = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional string biography = 6;
 * @return {string}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getBiography = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setBiography = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional School school = 7;
 * @return {?proto.manabie.bob.School}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.getSchool = function () {
  return (
    /** @type{?proto.manabie.bob.School} */
    jspb.Message.getWrapperField(this, schools_pb.School, 7)
  );
};
/** @param {?proto.manabie.bob.School|undefined} value */


proto.manabie.bob.UpdateProfileRequest.prototype.setSchool = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UpdateProfileRequest.prototype.clearSchool = function () {
  this.setSchool(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UpdateProfileRequest.prototype.hasSchool = function () {
  return jspb.Message.getField(this, 7) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpdateProfileResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpdateProfileResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpdateProfileResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpdateProfileResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpdateProfileResponse}
 */


proto.manabie.bob.UpdateProfileResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpdateProfileResponse();
  return proto.manabie.bob.UpdateProfileResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpdateProfileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpdateProfileResponse}
 */


proto.manabie.bob.UpdateProfileResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpdateProfileResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpdateProfileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpdateProfileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpdateProfileResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpdateProfileResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpdateProfileResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveLearningProgressRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveLearningProgressRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveLearningProgressRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveLearningProgressRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      sessionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveLearningProgressRequest}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveLearningProgressRequest();
  return proto.manabie.bob.RetrieveLearningProgressRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveLearningProgressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveLearningProgressRequest}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSessionId(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveLearningProgressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveLearningProgressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveLearningProgressRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getSessionId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string session_id = 2;
 * @return {string}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.getSessionId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.setSessionId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp from = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional google.protobuf.Timestamp to = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveLearningProgressRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveLearningProgressResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveLearningProgressResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveLearningProgressResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveLearningProgressResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveLearningProgressResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      dailiesList: jspb.Message.toObjectList(msg.getDailiesList(), proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveLearningProgressResponse}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveLearningProgressResponse();
  return proto.manabie.bob.RetrieveLearningProgressResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveLearningProgressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveLearningProgressResponse}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime();
        reader.readMessage(value, proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.deserializeBinaryFromReader);
        msg.addDailies(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveLearningProgressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveLearningProgressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveLearningProgressResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDailiesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalTimeSpentInDay: jspb.Message.getFieldWithDefault(msg, 1, 0),
      day: (f = msg.getDay()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime();
  return proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setTotalTimeSpentInDay(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setDay(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalTimeSpentInDay();

  if (f !== 0) {
    writer.writeInt64(1, f);
  }

  f = message.getDay();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional int64 total_time_spent_in_day = 1;
 * @return {number}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.getTotalTimeSpentInDay = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.setTotalTimeSpentInDay = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp day = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.getDay = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.setDay = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.clearDay = function () {
  this.setDay(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime.prototype.hasDay = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * repeated DailyLearningTime dailies = 1;
 * @return {!Array<!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime>}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.prototype.getDailiesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime>} value */


proto.manabie.bob.RetrieveLearningProgressResponse.prototype.setDailiesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime}
 */


proto.manabie.bob.RetrieveLearningProgressResponse.prototype.addDailies = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.RetrieveLearningProgressResponse.DailyLearningTime, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveLearningProgressResponse.prototype.clearDailiesList = function () {
  this.setDailiesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentEventLog.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentEventLog.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentEventLog} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentEventLog.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      eventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      eventType: jspb.Message.getFieldWithDefault(msg, 2, ""),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      payload: (f = msg.getPayload()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentEventLog}
 */


proto.manabie.bob.StudentEventLog.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentEventLog();
  return proto.manabie.bob.StudentEventLog.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentEventLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentEventLog}
 */


proto.manabie.bob.StudentEventLog.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEventId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setEventType(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 4:
        var value = new google_protobuf_struct_pb.Struct();
        reader.readMessage(value, google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
        msg.setPayload(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentEventLog.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentEventLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentEventLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentEventLog.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getEventId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getEventType();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getPayload();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_struct_pb.Struct.serializeBinaryToWriter);
  }
};
/**
 * optional string event_id = 1;
 * @return {string}
 */


proto.manabie.bob.StudentEventLog.prototype.getEventId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentEventLog.prototype.setEventId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string event_type = 2;
 * @return {string}
 */


proto.manabie.bob.StudentEventLog.prototype.getEventType = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentEventLog.prototype.setEventType = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentEventLog.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentEventLog.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentEventLog.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentEventLog.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional google.protobuf.Struct payload = 4;
 * @return {?proto.google.protobuf.Struct}
 */


proto.manabie.bob.StudentEventLog.prototype.getPayload = function () {
  return (
    /** @type{?proto.google.protobuf.Struct} */
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 4)
  );
};
/** @param {?proto.google.protobuf.Struct|undefined} value */


proto.manabie.bob.StudentEventLog.prototype.setPayload = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentEventLog.prototype.clearPayload = function () {
  this.setPayload(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentEventLog.prototype.hasPayload = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.StudentEventLogRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentEventLogRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentEventLogRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentEventLogRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentEventLogRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentEventLogsList: jspb.Message.toObjectList(msg.getStudentEventLogsList(), proto.manabie.bob.StudentEventLog.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentEventLogRequest}
 */


proto.manabie.bob.StudentEventLogRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentEventLogRequest();
  return proto.manabie.bob.StudentEventLogRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentEventLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentEventLogRequest}
 */


proto.manabie.bob.StudentEventLogRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentEventLog();
        reader.readMessage(value, proto.manabie.bob.StudentEventLog.deserializeBinaryFromReader);
        msg.addStudentEventLogs(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentEventLogRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentEventLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentEventLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentEventLogRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentEventLogsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.StudentEventLog.serializeBinaryToWriter);
  }
};
/**
 * repeated StudentEventLog student_event_logs = 1;
 * @return {!Array<!proto.manabie.bob.StudentEventLog>}
 */


proto.manabie.bob.StudentEventLogRequest.prototype.getStudentEventLogsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.StudentEventLog>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.StudentEventLog, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.StudentEventLog>} value */


proto.manabie.bob.StudentEventLogRequest.prototype.setStudentEventLogsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.StudentEventLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.StudentEventLog}
 */


proto.manabie.bob.StudentEventLogRequest.prototype.addStudentEventLogs = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.StudentEventLog, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.StudentEventLogRequest.prototype.clearStudentEventLogsList = function () {
  this.setStudentEventLogsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentComment.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentComment.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentComment} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentComment.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      commentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      coachId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      studentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      commentContent: jspb.Message.getFieldWithDefault(msg, 4, ""),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentComment}
 */


proto.manabie.bob.StudentComment.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentComment();
  return proto.manabie.bob.StudentComment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentComment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentComment}
 */


proto.manabie.bob.StudentComment.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCommentId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCoachId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCommentContent(value);
        break;

      case 5:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 6:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentComment.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentComment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentComment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentComment.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCommentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCoachId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getCommentContent();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(6, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string comment_id = 1;
 * @return {string}
 */


proto.manabie.bob.StudentComment.prototype.getCommentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentComment.prototype.setCommentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string coach_id = 2;
 * @return {string}
 */


proto.manabie.bob.StudentComment.prototype.getCoachId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentComment.prototype.setCoachId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string student_id = 3;
 * @return {string}
 */


proto.manabie.bob.StudentComment.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentComment.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string comment_content = 4;
 * @return {string}
 */


proto.manabie.bob.StudentComment.prototype.getCommentContent = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudentComment.prototype.setCommentContent = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional google.protobuf.Timestamp updated_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentComment.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentComment.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentComment.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentComment.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.StudentComment.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.StudentComment.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.StudentComment.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.StudentComment.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 6) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentEventLogResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentEventLogResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentEventLogResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentEventLogResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentEventLogResponse}
 */


proto.manabie.bob.StudentEventLogResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentEventLogResponse();
  return proto.manabie.bob.StudentEventLogResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentEventLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentEventLogResponse}
 */


proto.manabie.bob.StudentEventLogResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentEventLogResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentEventLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentEventLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentEventLogResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.StudentEventLogResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.StudentEventLogResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.AssignToCoachRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.AssignToCoachRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.AssignToCoachRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.AssignToCoachRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      coachId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      studentId: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.AssignToCoachRequest}
 */


proto.manabie.bob.AssignToCoachRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.AssignToCoachRequest();
  return proto.manabie.bob.AssignToCoachRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.AssignToCoachRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.AssignToCoachRequest}
 */


proto.manabie.bob.AssignToCoachRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCoachId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.AssignToCoachRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.AssignToCoachRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.AssignToCoachRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.AssignToCoachRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCoachId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string coach_id = 1;
 * @return {string}
 */


proto.manabie.bob.AssignToCoachRequest.prototype.getCoachId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.AssignToCoachRequest.prototype.setCoachId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string student_id = 2;
 * @return {string}
 */


proto.manabie.bob.AssignToCoachRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.AssignToCoachRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.AssignToCoachResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.AssignToCoachResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.AssignToCoachResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.AssignToCoachResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.AssignToCoachResponse}
 */


proto.manabie.bob.AssignToCoachResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.AssignToCoachResponse();
  return proto.manabie.bob.AssignToCoachResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.AssignToCoachResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.AssignToCoachResponse}
 */


proto.manabie.bob.AssignToCoachResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.AssignToCoachResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.AssignToCoachResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.AssignToCoachResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.AssignToCoachResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.AssignToCoachResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.AssignToCoachResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePresetStudyPlansRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePresetStudyPlansRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      name: jspb.Message.getFieldWithDefault(msg, 1, ""),
      country: jspb.Message.getFieldWithDefault(msg, 2, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 3, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlansRequest}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePresetStudyPlansRequest();
  return proto.manabie.bob.RetrievePresetStudyPlansRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlansRequest}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePresetStudyPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }
};
/**
 * optional string name = 1;
 * @return {string}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Country country = 2;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string grade = 3;
 * @return {string}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Subject subject = 4;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.RetrievePresetStudyPlansRequest.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePresetStudyPlansResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePresetStudyPlansResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePresetStudyPlansResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlansList: jspb.Message.toObjectList(msg.getPresetStudyPlansList(), courses_pb.PresetStudyPlan.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlansResponse}
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePresetStudyPlansResponse();
  return proto.manabie.bob.RetrievePresetStudyPlansResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlansResponse}
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.PresetStudyPlan();
        reader.readMessage(value, courses_pb.PresetStudyPlan.deserializeBinaryFromReader);
        msg.addPresetStudyPlans(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePresetStudyPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlansList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, courses_pb.PresetStudyPlan.serializeBinaryToWriter);
  }
};
/**
 * repeated PresetStudyPlan preset_study_plans = 1;
 * @return {!Array<!proto.manabie.bob.PresetStudyPlan>}
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.getPresetStudyPlansList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PresetStudyPlan>} */
    jspb.Message.getRepeatedWrapperField(this, courses_pb.PresetStudyPlan, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.PresetStudyPlan>} value */


proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.setPresetStudyPlansList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.PresetStudyPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PresetStudyPlan}
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.addPresetStudyPlans = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.PresetStudyPlan, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrievePresetStudyPlansResponse.prototype.clearPresetStudyPlansList = function () {
  this.setPresetStudyPlansList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest();
  return proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPresetStudyPlanId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string preset_study_plan_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.prototype.getPresetStudyPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesRequest.prototype.setPresetStudyPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanWeekliesList: jspb.Message.toObjectList(msg.getPresetStudyPlanWeekliesList(), courses_pb.PresetStudyPlanWeekly.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse();
  return proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.PresetStudyPlanWeekly();
        reader.readMessage(value, courses_pb.PresetStudyPlanWeekly.deserializeBinaryFromReader);
        msg.addPresetStudyPlanWeeklies(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanWeekliesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, courses_pb.PresetStudyPlanWeekly.serializeBinaryToWriter);
  }
};
/**
 * repeated PresetStudyPlanWeekly preset_study_plan_weeklies = 1;
 * @return {!Array<!proto.manabie.bob.PresetStudyPlanWeekly>}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.getPresetStudyPlanWeekliesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PresetStudyPlanWeekly>} */
    jspb.Message.getRepeatedWrapperField(this, courses_pb.PresetStudyPlanWeekly, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.PresetStudyPlanWeekly>} value */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.setPresetStudyPlanWeekliesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.PresetStudyPlanWeekly=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PresetStudyPlanWeekly}
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.addPresetStudyPlanWeeklies = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.PresetStudyPlanWeekly, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrievePresetStudyPlanWeekliesResponse.prototype.clearPresetStudyPlanWeekliesList = function () {
  this.setPresetStudyPlanWeekliesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.AssignPresetStudyPlansRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.AssignPresetStudyPlansRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      planDetailsList: jspb.Message.toObjectList(msg.getPlanDetailsList(), proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansRequest}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.AssignPresetStudyPlansRequest();
  return proto.manabie.bob.AssignPresetStudyPlansRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansRequest}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail();
        reader.readMessage(value, proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.deserializeBinaryFromReader);
        msg.addPlanDetails(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.AssignPresetStudyPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getPlanDetailsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      startWeek: jspb.Message.getFieldWithDefault(msg, 2, 0),
      startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail();
  return proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPresetStudyPlanId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setStartWeek(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStartDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStartWeek();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getStartDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string preset_study_plan_id = 1;
 * @return {string}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.getPresetStudyPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.setPresetStudyPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 start_week = 2;
 * @return {number}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.getStartWeek = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.setStartWeek = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp start_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.getStartDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.setStartDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.clearStartDate = function () {
  this.setStartDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail.prototype.hasStartDate = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated PlanDetail plan_details = 2;
 * @return {!Array<!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail>}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.getPlanDetailsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail>} value */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.setPlanDetailsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail}
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.addPlanDetails = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.manabie.bob.AssignPresetStudyPlansRequest.PlanDetail, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.AssignPresetStudyPlansRequest.prototype.clearPlanDetailsList = function () {
  this.setPlanDetailsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.AssignPresetStudyPlansResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.AssignPresetStudyPlansResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.AssignPresetStudyPlansResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.AssignPresetStudyPlansResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansResponse}
 */


proto.manabie.bob.AssignPresetStudyPlansResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.AssignPresetStudyPlansResponse();
  return proto.manabie.bob.AssignPresetStudyPlansResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.AssignPresetStudyPlansResponse}
 */


proto.manabie.bob.AssignPresetStudyPlansResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.AssignPresetStudyPlansResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.AssignPresetStudyPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.AssignPresetStudyPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.AssignPresetStudyPlansResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.AssignPresetStudyPlansResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.AssignPresetStudyPlansResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlansRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlansRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansRequest}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlansRequest();
  return proto.manabie.bob.RetrieveStudentStudyPlansRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansRequest}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlansRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlansResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlansResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      planWithStartDatesList: jspb.Message.toObjectList(msg.getPlanWithStartDatesList(), proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansResponse}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlansResponse();
  return proto.manabie.bob.RetrieveStudentStudyPlansResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansResponse}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate();
        reader.readMessage(value, proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.deserializeBinaryFromReader);
        msg.addPlanWithStartDates(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPlanWithStartDatesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      plan: (f = msg.getPlan()) && courses_pb.PresetStudyPlan.toObject(includeInstance, f),
      week: jspb.Message.getFieldWithDefault(msg, 2, 0),
      startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate();
  return proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.PresetStudyPlan();
        reader.readMessage(value, courses_pb.PresetStudyPlan.deserializeBinaryFromReader);
        msg.setPlan(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setWeek(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStartDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPlan();

  if (f != null) {
    writer.writeMessage(1, f, courses_pb.PresetStudyPlan.serializeBinaryToWriter);
  }

  f = message.getWeek();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getStartDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional PresetStudyPlan plan = 1;
 * @return {?proto.manabie.bob.PresetStudyPlan}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.getPlan = function () {
  return (
    /** @type{?proto.manabie.bob.PresetStudyPlan} */
    jspb.Message.getWrapperField(this, courses_pb.PresetStudyPlan, 1)
  );
};
/** @param {?proto.manabie.bob.PresetStudyPlan|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.setPlan = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.clearPlan = function () {
  this.setPlan(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.hasPlan = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional int32 week = 2;
 * @return {number}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.getWeek = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.setWeek = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp start_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.getStartDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.setStartDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.clearStartDate = function () {
  this.setStartDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate.prototype.hasStartDate = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * repeated PlanWithStartDate plan_with_start_dates = 1;
 * @return {!Array<!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate>}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.getPlanWithStartDatesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate>} value */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.setPlanWithStartDatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.addPlanWithStartDates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.RetrieveStudentStudyPlansResponse.PlanWithStartDate, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveStudentStudyPlansResponse.prototype.clearPlanWithStartDatesList = function () {
  this.setPlanWithStartDatesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      retrieveAll: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest();
  return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      case 4:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setRetrieveAll(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getRetrieveAll();

  if (f) {
    writer.writeBool(4, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional bool retrieve_all = 4;
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.getRetrieveAll = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 4, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesRequest.prototype.setRetrieveAll = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicWithStartDatesList: jspb.Message.toObjectList(msg.getTopicWithStartDatesList(), proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse();
  return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate();
        reader.readMessage(value, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.deserializeBinaryFromReader);
        msg.addTopicWithStartDates(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicWithStartDatesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      topicName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      totalLos: jspb.Message.getFieldWithDefault(msg, 4, 0),
      totalFinishedLos: jspb.Message.getFieldWithDefault(msg, 5, 0),
      assignedBy: (f = msg.getAssignedBy()) && user_pb.BasicProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate();
  return proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicName(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStartDate(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLos(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalFinishedLos(value);
        break;

      case 6:
        var value = new user_pb.BasicProfile();
        reader.readMessage(value, user_pb.BasicProfile.deserializeBinaryFromReader);
        msg.setAssignedBy(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTopicName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getStartDate();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTotalLos();

  if (f !== 0) {
    writer.writeInt32(4, f);
  }

  f = message.getTotalFinishedLos();

  if (f !== 0) {
    writer.writeInt32(5, f);
  }

  f = message.getAssignedBy();

  if (f != null) {
    writer.writeMessage(6, f, user_pb.BasicProfile.serializeBinaryToWriter);
  }
};
/**
 * optional string topic_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getTopicId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setTopicId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string topic_name = 2;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getTopicName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setTopicName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp start_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getStartDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setStartDate = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.clearStartDate = function () {
  this.setStartDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.hasStartDate = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional int32 total_los = 4;
 * @return {number}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getTotalLos = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setTotalLos = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 total_finished_los = 5;
 * @return {number}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getTotalFinishedLos = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setTotalFinishedLos = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional BasicProfile assigned_by = 6;
 * @return {?proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.getAssignedBy = function () {
  return (
    /** @type{?proto.manabie.bob.BasicProfile} */
    jspb.Message.getWrapperField(this, user_pb.BasicProfile, 6)
  );
};
/** @param {?proto.manabie.bob.BasicProfile|undefined} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.setAssignedBy = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.clearAssignedBy = function () {
  this.setAssignedBy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate.prototype.hasAssignedBy = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * repeated TopicWithStartDate topic_with_start_dates = 1;
 * @return {!Array<!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate>}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.getTopicWithStartDatesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate>} value */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.setTopicWithStartDatesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate}
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.addTopicWithStartDates = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.TopicWithStartDate, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveStudentStudyPlanWeekliesResponse.prototype.clearTopicWithStartDatesList = function () {
  this.setTopicWithStartDatesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentStat.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentStat.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentStat} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentStat.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalLearningTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
      totalLoFinished: jspb.Message.getFieldWithDefault(msg, 2, 0),
      totalLo: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentStat}
 */


proto.manabie.bob.StudentStat.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentStat();
  return proto.manabie.bob.StudentStat.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentStat}
 */


proto.manabie.bob.StudentStat.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLearningTime(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLoFinished(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentStat.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentStat.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalLearningTime();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getTotalLoFinished();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getTotalLo();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional int32 total_learning_time = 1;
 * @return {number}
 */


proto.manabie.bob.StudentStat.prototype.getTotalLearningTime = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.StudentStat.prototype.setTotalLearningTime = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 total_lo_finished = 2;
 * @return {number}
 */


proto.manabie.bob.StudentStat.prototype.getTotalLoFinished = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.StudentStat.prototype.setTotalLoFinished = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 total_lo = 3;
 * @return {number}
 */


proto.manabie.bob.StudentStat.prototype.getTotalLo = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.StudentStat.prototype.setTotalLo = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStatRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStatRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStatRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStatRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStatRequest}
 */


proto.manabie.bob.RetrieveStudentStatRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStatRequest();
  return proto.manabie.bob.RetrieveStudentStatRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStatRequest}
 */


proto.manabie.bob.RetrieveStudentStatRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStatRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStatRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentStatRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentStatRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentStatResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentStatResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentStatResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentStatResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentStat: (f = msg.getStudentStat()) && proto.manabie.bob.StudentStat.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentStatResponse}
 */


proto.manabie.bob.RetrieveStudentStatResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentStatResponse();
  return proto.manabie.bob.RetrieveStudentStatResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentStatResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentStatResponse}
 */


proto.manabie.bob.RetrieveStudentStatResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentStat();
        reader.readMessage(value, proto.manabie.bob.StudentStat.deserializeBinaryFromReader);
        msg.setStudentStat(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentStatResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentStatResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentStatResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentStatResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentStat();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.StudentStat.serializeBinaryToWriter);
  }
};
/**
 * optional StudentStat student_stat = 1;
 * @return {?proto.manabie.bob.StudentStat}
 */


proto.manabie.bob.RetrieveStudentStatResponse.prototype.getStudentStat = function () {
  return (
    /** @type{?proto.manabie.bob.StudentStat} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.StudentStat, 1)
  );
};
/** @param {?proto.manabie.bob.StudentStat|undefined} value */


proto.manabie.bob.RetrieveStudentStatResponse.prototype.setStudentStat = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveStudentStatResponse.prototype.clearStudentStat = function () {
  this.setStudentStat(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveStudentStatResponse.prototype.hasStudentStat = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RenewStudentBillingDateRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RenewStudentBillingDateRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RenewStudentBillingDateRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RenewStudentBillingDateRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      days: jspb.Message.getFieldWithDefault(msg, 2, 0),
      start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RenewStudentBillingDateRequest}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RenewStudentBillingDateRequest();
  return proto.manabie.bob.RenewStudentBillingDateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RenewStudentBillingDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RenewStudentBillingDateRequest}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setDays(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStart(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setEnd(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RenewStudentBillingDateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RenewStudentBillingDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RenewStudentBillingDateRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getDays();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getStart();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEnd();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 days = 2;
 * @return {number}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.getDays = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.setDays = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp start = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.getStart = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.setStart = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.clearStart = function () {
  this.setStart(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.hasStart = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional google.protobuf.Timestamp end = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.getEnd = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.setEnd = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.clearEnd = function () {
  this.setEnd(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RenewStudentBillingDateRequest.prototype.hasEnd = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.BillingHistory.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.BillingHistory.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.BillingHistory} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.BillingHistory.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      billingId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      studentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      generatorId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      generatorEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
      start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.BillingHistory}
 */


proto.manabie.bob.BillingHistory.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.BillingHistory();
  return proto.manabie.bob.BillingHistory.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.BillingHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.BillingHistory}
 */


proto.manabie.bob.BillingHistory.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBillingId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGeneratorId(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGeneratorEmail(value);
        break;

      case 5:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStart(value);
        break;

      case 6:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setEnd(value);
        break;

      case 7:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.BillingHistory.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.BillingHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.BillingHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.BillingHistory.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBillingId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getGeneratorId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getGeneratorEmail();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getStart();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getEnd();

  if (f != null) {
    writer.writeMessage(6, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(7, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string billing_id = 1;
 * @return {string}
 */


proto.manabie.bob.BillingHistory.prototype.getBillingId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BillingHistory.prototype.setBillingId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string student_id = 2;
 * @return {string}
 */


proto.manabie.bob.BillingHistory.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BillingHistory.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string generator_id = 3;
 * @return {string}
 */


proto.manabie.bob.BillingHistory.prototype.getGeneratorId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BillingHistory.prototype.setGeneratorId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string generator_email = 4;
 * @return {string}
 */


proto.manabie.bob.BillingHistory.prototype.getGeneratorEmail = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.BillingHistory.prototype.setGeneratorEmail = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional google.protobuf.Timestamp start = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.BillingHistory.prototype.getStart = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.BillingHistory.prototype.setStart = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.BillingHistory.prototype.clearStart = function () {
  this.setStart(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.BillingHistory.prototype.hasStart = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * optional google.protobuf.Timestamp end = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.BillingHistory.prototype.getEnd = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.BillingHistory.prototype.setEnd = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.BillingHistory.prototype.clearEnd = function () {
  this.setEnd(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.BillingHistory.prototype.hasEnd = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.BillingHistory.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.BillingHistory.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.BillingHistory.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.BillingHistory.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.BillingHistory.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.BillingHistory.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.BillingHistory.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.BillingHistory.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RenewStudentBillingDateResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RenewStudentBillingDateResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RenewStudentBillingDateResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RenewStudentBillingDateResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RenewStudentBillingDateResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      billingsList: jspb.Message.toObjectList(msg.getBillingsList(), proto.manabie.bob.BillingHistory.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RenewStudentBillingDateResponse}
 */


proto.manabie.bob.RenewStudentBillingDateResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RenewStudentBillingDateResponse();
  return proto.manabie.bob.RenewStudentBillingDateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RenewStudentBillingDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RenewStudentBillingDateResponse}
 */


proto.manabie.bob.RenewStudentBillingDateResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.BillingHistory();
        reader.readMessage(value, proto.manabie.bob.BillingHistory.deserializeBinaryFromReader);
        msg.addBillings(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RenewStudentBillingDateResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RenewStudentBillingDateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RenewStudentBillingDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RenewStudentBillingDateResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBillingsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.BillingHistory.serializeBinaryToWriter);
  }
};
/**
 * repeated BillingHistory billings = 1;
 * @return {!Array<!proto.manabie.bob.BillingHistory>}
 */


proto.manabie.bob.RenewStudentBillingDateResponse.prototype.getBillingsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.BillingHistory>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.BillingHistory, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.BillingHistory>} value */


proto.manabie.bob.RenewStudentBillingDateResponse.prototype.setBillingsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.BillingHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.BillingHistory}
 */


proto.manabie.bob.RenewStudentBillingDateResponse.prototype.addBillings = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.BillingHistory, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RenewStudentBillingDateResponse.prototype.clearBillingsList = function () {
  this.setBillingsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentBillingHistoryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentBillingHistoryRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentBillingHistoryRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentBillingHistoryRequest();
  return proto.manabie.bob.RetrieveStudentBillingHistoryRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentBillingHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentBillingHistoryRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentBillingHistoryResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentBillingHistoryResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      billingsList: jspb.Message.toObjectList(msg.getBillingsList(), proto.manabie.bob.BillingHistory.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentBillingHistoryResponse}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentBillingHistoryResponse();
  return proto.manabie.bob.RetrieveStudentBillingHistoryResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentBillingHistoryResponse}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.BillingHistory();
        reader.readMessage(value, proto.manabie.bob.BillingHistory.deserializeBinaryFromReader);
        msg.addBillings(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentBillingHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentBillingHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBillingsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.BillingHistory.serializeBinaryToWriter);
  }
};
/**
 * repeated BillingHistory billings = 1;
 * @return {!Array<!proto.manabie.bob.BillingHistory>}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.getBillingsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.BillingHistory>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.BillingHistory, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.BillingHistory>} value */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.setBillingsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.BillingHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.BillingHistory}
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.addBillings = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.BillingHistory, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveStudentBillingHistoryResponse.prototype.clearBillingsList = function () {
  this.setBillingsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.FindStudentRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.FindStudentRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.FindStudentRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.FindStudentRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      phone: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.FindStudentRequest}
 */


proto.manabie.bob.FindStudentRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.FindStudentRequest();
  return proto.manabie.bob.FindStudentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.FindStudentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.FindStudentRequest}
 */


proto.manabie.bob.FindStudentRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPhone(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.FindStudentRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.FindStudentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.FindStudentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.FindStudentRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPhone();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string phone = 1;
 * @return {string}
 */


proto.manabie.bob.FindStudentRequest.prototype.getPhone = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.FindStudentRequest.prototype.setPhone = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.FindStudentResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.FindStudentResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.FindStudentResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.FindStudentResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      profile: (f = msg.getProfile()) && proto.manabie.bob.StudentProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.FindStudentResponse}
 */


proto.manabie.bob.FindStudentResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.FindStudentResponse();
  return proto.manabie.bob.FindStudentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.FindStudentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.FindStudentResponse}
 */


proto.manabie.bob.FindStudentResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentProfile();
        reader.readMessage(value, proto.manabie.bob.StudentProfile.deserializeBinaryFromReader);
        msg.setProfile(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.FindStudentResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.FindStudentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.FindStudentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.FindStudentResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getProfile();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.StudentProfile.serializeBinaryToWriter);
  }
};
/**
 * optional StudentProfile profile = 1;
 * @return {?proto.manabie.bob.StudentProfile}
 */


proto.manabie.bob.FindStudentResponse.prototype.getProfile = function () {
  return (
    /** @type{?proto.manabie.bob.StudentProfile} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.StudentProfile, 1)
  );
};
/** @param {?proto.manabie.bob.StudentProfile|undefined} value */


proto.manabie.bob.FindStudentResponse.prototype.setProfile = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.FindStudentResponse.prototype.clearProfile = function () {
  this.setProfile(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.FindStudentResponse.prototype.hasProfile = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertStudentCommentRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertStudentCommentRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertStudentCommentRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertStudentCommentRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentComment: (f = msg.getStudentComment()) && proto.manabie.bob.StudentComment.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertStudentCommentRequest}
 */


proto.manabie.bob.UpsertStudentCommentRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertStudentCommentRequest();
  return proto.manabie.bob.UpsertStudentCommentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertStudentCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertStudentCommentRequest}
 */


proto.manabie.bob.UpsertStudentCommentRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudentComment();
        reader.readMessage(value, proto.manabie.bob.StudentComment.deserializeBinaryFromReader);
        msg.setStudentComment(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertStudentCommentRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertStudentCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertStudentCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertStudentCommentRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentComment();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.StudentComment.serializeBinaryToWriter);
  }
};
/**
 * optional StudentComment student_comment = 1;
 * @return {?proto.manabie.bob.StudentComment}
 */


proto.manabie.bob.UpsertStudentCommentRequest.prototype.getStudentComment = function () {
  return (
    /** @type{?proto.manabie.bob.StudentComment} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.StudentComment, 1)
  );
};
/** @param {?proto.manabie.bob.StudentComment|undefined} value */


proto.manabie.bob.UpsertStudentCommentRequest.prototype.setStudentComment = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.UpsertStudentCommentRequest.prototype.clearStudentComment = function () {
  this.setStudentComment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.UpsertStudentCommentRequest.prototype.hasStudentComment = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertStudentCommentResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertStudentCommentResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertStudentCommentResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertStudentCommentResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertStudentCommentResponse}
 */


proto.manabie.bob.UpsertStudentCommentResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertStudentCommentResponse();
  return proto.manabie.bob.UpsertStudentCommentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertStudentCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertStudentCommentResponse}
 */


proto.manabie.bob.UpsertStudentCommentResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertStudentCommentResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertStudentCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertStudentCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertStudentCommentResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpsertStudentCommentResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpsertStudentCommentResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentCommentRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentCommentRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentCommentRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentCommentRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentCommentRequest}
 */


proto.manabie.bob.RetrieveStudentCommentRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentCommentRequest();
  return proto.manabie.bob.RetrieveStudentCommentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentCommentRequest}
 */


proto.manabie.bob.RetrieveStudentCommentRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentCommentRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentCommentRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudentCommentRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudentCommentRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CommentInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CommentInfo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CommentInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CommentInfo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      coachName: jspb.Message.getFieldWithDefault(msg, 1, ""),
      studentComment: (f = msg.getStudentComment()) && proto.manabie.bob.StudentComment.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CommentInfo}
 */


proto.manabie.bob.CommentInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CommentInfo();
  return proto.manabie.bob.CommentInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CommentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CommentInfo}
 */


proto.manabie.bob.CommentInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCoachName(value);
        break;

      case 2:
        var value = new proto.manabie.bob.StudentComment();
        reader.readMessage(value, proto.manabie.bob.StudentComment.deserializeBinaryFromReader);
        msg.setStudentComment(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CommentInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CommentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CommentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CommentInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCoachName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStudentComment();

  if (f != null) {
    writer.writeMessage(2, f, proto.manabie.bob.StudentComment.serializeBinaryToWriter);
  }
};
/**
 * optional string coach_name = 1;
 * @return {string}
 */


proto.manabie.bob.CommentInfo.prototype.getCoachName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CommentInfo.prototype.setCoachName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional StudentComment student_comment = 2;
 * @return {?proto.manabie.bob.StudentComment}
 */


proto.manabie.bob.CommentInfo.prototype.getStudentComment = function () {
  return (
    /** @type{?proto.manabie.bob.StudentComment} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.StudentComment, 2)
  );
};
/** @param {?proto.manabie.bob.StudentComment|undefined} value */


proto.manabie.bob.CommentInfo.prototype.setStudentComment = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CommentInfo.prototype.clearStudentComment = function () {
  this.setStudentComment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CommentInfo.prototype.hasStudentComment = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveStudentCommentResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudentCommentResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudentCommentResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudentCommentResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudentCommentResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      commentList: jspb.Message.toObjectList(msg.getCommentList(), proto.manabie.bob.CommentInfo.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudentCommentResponse}
 */


proto.manabie.bob.RetrieveStudentCommentResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudentCommentResponse();
  return proto.manabie.bob.RetrieveStudentCommentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudentCommentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudentCommentResponse}
 */


proto.manabie.bob.RetrieveStudentCommentResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.CommentInfo();
        reader.readMessage(value, proto.manabie.bob.CommentInfo.deserializeBinaryFromReader);
        msg.addComment(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudentCommentResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudentCommentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudentCommentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudentCommentResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCommentList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.CommentInfo.serializeBinaryToWriter);
  }
};
/**
 * repeated CommentInfo comment = 1;
 * @return {!Array<!proto.manabie.bob.CommentInfo>}
 */


proto.manabie.bob.RetrieveStudentCommentResponse.prototype.getCommentList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.CommentInfo>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.CommentInfo, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.CommentInfo>} value */


proto.manabie.bob.RetrieveStudentCommentResponse.prototype.setCommentList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.CommentInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.CommentInfo}
 */


proto.manabie.bob.RetrieveStudentCommentResponse.prototype.addComment = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.CommentInfo, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveStudentCommentResponse.prototype.clearCommentList = function () {
  this.setCommentList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveDailyLOFinishedRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveDailyLOFinishedRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedRequest}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveDailyLOFinishedRequest();
  return proto.manabie.bob.RetrieveDailyLOFinishedRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedRequest}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveDailyLOFinishedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveDailyLOFinishedRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveDailyLOFinishedResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveDailyLOFinishedResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalLo: jspb.Message.getFieldWithDefault(msg, 1, 0),
      dailiesList: jspb.Message.toObjectList(msg.getDailiesList(), proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedResponse}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveDailyLOFinishedResponse();
  return proto.manabie.bob.RetrieveDailyLOFinishedResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedResponse}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLo(value);
        break;

      case 2:
        var value = new proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished();
        reader.readMessage(value, proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.deserializeBinaryFromReader);
        msg.addDailies(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalLo();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getDailiesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalLoFinished: jspb.Message.getFieldWithDefault(msg, 1, 0),
      day: (f = msg.getDay()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished();
  return proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLoFinished(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setDay(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalLoFinished();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getDay();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional int32 total_lo_finished = 1;
 * @return {number}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.getTotalLoFinished = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.setTotalLoFinished = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp day = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.getDay = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.setDay = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.clearDay = function () {
  this.setDay(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished.prototype.hasDay = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional int32 total_lo = 1;
 * @return {number}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.getTotalLo = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.setTotalLo = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated DailyLOFinished dailies = 2;
 * @return {!Array<!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished>}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.getDailiesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished>} value */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.setDailiesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished}
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.addDailies = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.manabie.bob.RetrieveDailyLOFinishedResponse.DailyLOFinished, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveDailyLOFinishedResponse.prototype.clearDailiesList = function () {
  this.setDailiesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudyAheadTopic.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudyAheadTopic.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudyAheadTopic} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudyAheadTopic.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      week: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudyAheadTopic}
 */


proto.manabie.bob.StudyAheadTopic.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudyAheadTopic();
  return proto.manabie.bob.StudyAheadTopic.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudyAheadTopic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudyAheadTopic}
 */


proto.manabie.bob.StudyAheadTopic.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setWeek(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudyAheadTopic.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudyAheadTopic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudyAheadTopic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudyAheadTopic.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getWeek();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional string topic_id = 1;
 * @return {string}
 */


proto.manabie.bob.StudyAheadTopic.prototype.getTopicId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.StudyAheadTopic.prototype.setTopicId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 week = 2;
 * @return {number}
 */


proto.manabie.bob.StudyAheadTopic.prototype.getWeek = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.StudyAheadTopic.prototype.setWeek = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudyAheadTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudyAheadTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudyAheadTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudyAheadTopicsRequest();
  return proto.manabie.bob.RetrieveStudyAheadTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudyAheadTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveStudyAheadTopicsRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveStudyAheadTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveStudyAheadTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studyAheadTopicsList: jspb.Message.toObjectList(msg.getStudyAheadTopicsList(), proto.manabie.bob.StudyAheadTopic.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveStudyAheadTopicsResponse}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveStudyAheadTopicsResponse();
  return proto.manabie.bob.RetrieveStudyAheadTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveStudyAheadTopicsResponse}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.StudyAheadTopic();
        reader.readMessage(value, proto.manabie.bob.StudyAheadTopic.deserializeBinaryFromReader);
        msg.addStudyAheadTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveStudyAheadTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveStudyAheadTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudyAheadTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.StudyAheadTopic.serializeBinaryToWriter);
  }
};
/**
 * repeated StudyAheadTopic study_ahead_topics = 1;
 * @return {!Array<!proto.manabie.bob.StudyAheadTopic>}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.getStudyAheadTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.StudyAheadTopic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.StudyAheadTopic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.StudyAheadTopic>} value */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.setStudyAheadTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.StudyAheadTopic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.StudyAheadTopic}
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.addStudyAheadTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.StudyAheadTopic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveStudyAheadTopicsResponse.prototype.clearStudyAheadTopicsList = function () {
  this.setStudyAheadTopicsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveTotalLOsFinishedRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveTotalLOsFinishedRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveTotalLOsFinishedRequest();
  return proto.manabie.bob.RetrieveTotalLOsFinishedRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveTotalLOsFinishedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveTotalLOsFinishedResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveTotalLOsFinishedResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalLosFinished: jspb.Message.getFieldWithDefault(msg, 1, 0),
      totalLos: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveTotalLOsFinishedResponse}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveTotalLOsFinishedResponse();
  return proto.manabie.bob.RetrieveTotalLOsFinishedResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveTotalLOsFinishedResponse}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLosFinished(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLos(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveTotalLOsFinishedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveTotalLOsFinishedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalLosFinished();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getTotalLos();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional int32 total_los_finished = 1;
 * @return {number}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.getTotalLosFinished = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.setTotalLosFinished = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 total_los = 2;
 * @return {number}
 */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.getTotalLos = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveTotalLOsFinishedResponse.prototype.setTotalLos = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CountTotalLOsFinishedRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CountTotalLOsFinishedRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CountTotalLOsFinishedRequest}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CountTotalLOsFinishedRequest();
  return proto.manabie.bob.CountTotalLOsFinishedRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CountTotalLOsFinishedRequest}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CountTotalLOsFinishedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CountTotalLOsFinishedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.CountTotalLOsFinishedRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.CountTotalLOsFinishedResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.CountTotalLOsFinishedResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.CountTotalLOsFinishedResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.CountTotalLOsFinishedResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      totalLosFinished: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.CountTotalLOsFinishedResponse}
 */


proto.manabie.bob.CountTotalLOsFinishedResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.CountTotalLOsFinishedResponse();
  return proto.manabie.bob.CountTotalLOsFinishedResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.CountTotalLOsFinishedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.CountTotalLOsFinishedResponse}
 */


proto.manabie.bob.CountTotalLOsFinishedResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLosFinished(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.CountTotalLOsFinishedResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.CountTotalLOsFinishedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.CountTotalLOsFinishedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.CountTotalLOsFinishedResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalLosFinished();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }
};
/**
 * optional int32 total_los_finished = 1;
 * @return {number}
 */


proto.manabie.bob.CountTotalLOsFinishedResponse.prototype.getTotalLosFinished = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.CountTotalLOsFinishedResponse.prototype.setTotalLosFinished = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveArchivedTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveArchivedTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveArchivedTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveArchivedTopicsRequest}
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveArchivedTopicsRequest();
  return proto.manabie.bob.RetrieveArchivedTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveArchivedTopicsRequest}
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveArchivedTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveArchivedTopicsRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveArchivedTopicsRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ArchivedTopic.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ArchivedTopic.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ArchivedTopic} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ArchivedTopic.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      status: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ArchivedTopic}
 */


proto.manabie.bob.ArchivedTopic.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ArchivedTopic();
  return proto.manabie.bob.ArchivedTopic.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ArchivedTopic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ArchivedTopic}
 */


proto.manabie.bob.ArchivedTopic.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicId(value);
        break;

      case 2:
        var value =
        /** @type {!proto.manabie.bob.ArchivedTopic.Status} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ArchivedTopic.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ArchivedTopic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ArchivedTopic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ArchivedTopic.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(2, f);
  }
};
/**
 * @enum {number}
 */


proto.manabie.bob.ArchivedTopic.Status = {
  ARCHIVED_STATUS_COMPLETED: 0,
  ARCHIVED_STATUS_EXPIRED: 1
};
/**
 * optional string topic_id = 1;
 * @return {string}
 */

proto.manabie.bob.ArchivedTopic.prototype.getTopicId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.ArchivedTopic.prototype.setTopicId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Status status = 2;
 * @return {!proto.manabie.bob.ArchivedTopic.Status}
 */


proto.manabie.bob.ArchivedTopic.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.ArchivedTopic.Status} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {!proto.manabie.bob.ArchivedTopic.Status} value */


proto.manabie.bob.ArchivedTopic.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveArchivedTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveArchivedTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveArchivedTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.ArchivedTopic.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveArchivedTopicsResponse}
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveArchivedTopicsResponse();
  return proto.manabie.bob.RetrieveArchivedTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveArchivedTopicsResponse}
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.ArchivedTopic();
        reader.readMessage(value, proto.manabie.bob.ArchivedTopic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveArchivedTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveArchivedTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.ArchivedTopic.serializeBinaryToWriter);
  }
};
/**
 * repeated ArchivedTopic topics = 1;
 * @return {!Array<!proto.manabie.bob.ArchivedTopic>}
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.ArchivedTopic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.ArchivedTopic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.ArchivedTopic>} value */


proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.ArchivedTopic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.ArchivedTopic}
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.ArchivedTopic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveArchivedTopicsResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentPermissionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentPermissionRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentPermissionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentPermissionRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentPermissionRequest}
 */


proto.manabie.bob.StudentPermissionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentPermissionRequest();
  return proto.manabie.bob.StudentPermissionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentPermissionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentPermissionRequest}
 */


proto.manabie.bob.StudentPermissionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentPermissionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentPermissionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentPermissionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentPermissionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.PermissionAllowGrade.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PermissionAllowGrade.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PermissionAllowGrade.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PermissionAllowGrade} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PermissionAllowGrade.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      subject: jspb.Message.getFieldWithDefault(msg, 1, 0),
      planPrivilegesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PermissionAllowGrade}
 */


proto.manabie.bob.PermissionAllowGrade.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PermissionAllowGrade();
  return proto.manabie.bob.PermissionAllowGrade.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PermissionAllowGrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PermissionAllowGrade}
 */


proto.manabie.bob.PermissionAllowGrade.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 2:
        var value =
        /** @type {!Array<!proto.manabie.bob.PlanPrivilege>} */
        reader.readPackedEnum();
        msg.setPlanPrivilegesList(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PermissionAllowGrade.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PermissionAllowGrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PermissionAllowGrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PermissionAllowGrade.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getPlanPrivilegesList();

  if (f.length > 0) {
    writer.writePackedEnum(2, f);
  }
};
/**
 * optional Subject subject = 1;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.PermissionAllowGrade.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.PermissionAllowGrade.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * repeated PlanPrivilege plan_privileges = 2;
 * @return {!Array<!proto.manabie.bob.PlanPrivilege>}
 */


proto.manabie.bob.PermissionAllowGrade.prototype.getPlanPrivilegesList = function () {
  return (
    /** @type {!Array<!proto.manabie.bob.PlanPrivilege>} */
    jspb.Message.getRepeatedField(this, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.PlanPrivilege>} value */


proto.manabie.bob.PermissionAllowGrade.prototype.setPlanPrivilegesList = function (value) {
  jspb.Message.setField(this, 2, value || []);
};
/**
 * @param {!proto.manabie.bob.PlanPrivilege} value
 * @param {number=} opt_index
 */


proto.manabie.bob.PermissionAllowGrade.prototype.addPlanPrivileges = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.PermissionAllowGrade.prototype.clearPlanPrivilegesList = function () {
  this.setPlanPrivilegesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Permission.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Permission.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Permission.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Permission} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Permission.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      permissionallowgradesList: jspb.Message.toObjectList(msg.getPermissionallowgradesList(), proto.manabie.bob.PermissionAllowGrade.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Permission}
 */


proto.manabie.bob.Permission.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Permission();
  return proto.manabie.bob.Permission.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Permission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Permission}
 */


proto.manabie.bob.Permission.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.PermissionAllowGrade();
        reader.readMessage(value, proto.manabie.bob.PermissionAllowGrade.deserializeBinaryFromReader);
        msg.addPermissionallowgrades(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Permission.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Permission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Permission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Permission.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPermissionallowgradesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.PermissionAllowGrade.serializeBinaryToWriter);
  }
};
/**
 * repeated PermissionAllowGrade permissionAllowGrades = 1;
 * @return {!Array<!proto.manabie.bob.PermissionAllowGrade>}
 */


proto.manabie.bob.Permission.prototype.getPermissionallowgradesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PermissionAllowGrade>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.PermissionAllowGrade, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.PermissionAllowGrade>} value */


proto.manabie.bob.Permission.prototype.setPermissionallowgradesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.PermissionAllowGrade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PermissionAllowGrade}
 */


proto.manabie.bob.Permission.prototype.addPermissionallowgrades = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.PermissionAllowGrade, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Permission.prototype.clearPermissionallowgradesList = function () {
  this.setPermissionallowgradesList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.StudentPermissionResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.StudentPermissionResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.StudentPermissionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.StudentPermissionResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      permissionsMap: (f = msg.getPermissionsMap()) ? f.toObject(includeInstance, proto.manabie.bob.Permission.toObject) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.StudentPermissionResponse}
 */


proto.manabie.bob.StudentPermissionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.StudentPermissionResponse();
  return proto.manabie.bob.StudentPermissionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.StudentPermissionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.StudentPermissionResponse}
 */


proto.manabie.bob.StudentPermissionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getPermissionsMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.manabie.bob.Permission.deserializeBinaryFromReader, 0);
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.StudentPermissionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.StudentPermissionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.StudentPermissionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.StudentPermissionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPermissionsMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.manabie.bob.Permission.serializeBinaryToWriter);
  }
};
/**
 * map<int32, Permission> permissions = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.manabie.bob.Permission>}
 */


proto.manabie.bob.StudentPermissionResponse.prototype.getPermissionsMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<number,!proto.manabie.bob.Permission>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, proto.manabie.bob.Permission)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 */


proto.manabie.bob.StudentPermissionResponse.prototype.clearPermissionsMap = function () {
  this.getPermissionsMap().clear();
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ApplyActivationCodeRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ApplyActivationCodeRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ApplyActivationCodeRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ApplyActivationCodeRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0),
      activationCode: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ApplyActivationCodeRequest}
 */


proto.manabie.bob.ApplyActivationCodeRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ApplyActivationCodeRequest();
  return proto.manabie.bob.ApplyActivationCodeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ApplyActivationCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ApplyActivationCodeRequest}
 */


proto.manabie.bob.ApplyActivationCodeRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setActivationCode(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ApplyActivationCodeRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ApplyActivationCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ApplyActivationCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ApplyActivationCodeRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getActivationCode();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.ApplyActivationCodeRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.ApplyActivationCodeRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string activation_code = 2;
 * @return {string}
 */


proto.manabie.bob.ApplyActivationCodeRequest.prototype.getActivationCode = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.ApplyActivationCodeRequest.prototype.setActivationCode = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ApplyActivationCodeResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ApplyActivationCodeResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ApplyActivationCodeResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ApplyActivationCodeResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      plan: jspb.Message.getFieldWithDefault(msg, 2, ""),
      expiredAt: (f = msg.getExpiredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ApplyActivationCodeResponse}
 */


proto.manabie.bob.ApplyActivationCodeResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ApplyActivationCodeResponse();
  return proto.manabie.bob.ApplyActivationCodeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ApplyActivationCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ApplyActivationCodeResponse}
 */


proto.manabie.bob.ApplyActivationCodeResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPlan(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setExpiredAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ApplyActivationCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ApplyActivationCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ApplyActivationCodeResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }

  f = message.getPlan();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getExpiredAt();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string plan = 2;
 * @return {string}
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.getPlan = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.setPlan = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional google.protobuf.Timestamp expired_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.getExpiredAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.setExpiredAt = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.clearExpiredAt = function () {
  this.setExpiredAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.ApplyActivationCodeResponse.prototype.hasExpiredAt = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.TopicOverdue.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.TopicOverdue.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.TopicOverdue} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.TopicOverdue.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topic: (f = msg.getTopic()) && courses_pb.Topic.toObject(includeInstance, f),
      dueDate: (f = msg.getDueDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      assignedBy: (f = msg.getAssignedBy()) && user_pb.BasicProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.TopicOverdue}
 */


proto.manabie.bob.TopicOverdue.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.TopicOverdue();
  return proto.manabie.bob.TopicOverdue.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.TopicOverdue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.TopicOverdue}
 */


proto.manabie.bob.TopicOverdue.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.Topic();
        reader.readMessage(value, courses_pb.Topic.deserializeBinaryFromReader);
        msg.setTopic(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setDueDate(value);
        break;

      case 3:
        var value = new user_pb.BasicProfile();
        reader.readMessage(value, user_pb.BasicProfile.deserializeBinaryFromReader);
        msg.setAssignedBy(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.TopicOverdue.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.TopicOverdue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.TopicOverdue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.TopicOverdue.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopic();

  if (f != null) {
    writer.writeMessage(1, f, courses_pb.Topic.serializeBinaryToWriter);
  }

  f = message.getDueDate();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getAssignedBy();

  if (f != null) {
    writer.writeMessage(3, f, user_pb.BasicProfile.serializeBinaryToWriter);
  }
};
/**
 * optional Topic topic = 1;
 * @return {?proto.manabie.bob.Topic}
 */


proto.manabie.bob.TopicOverdue.prototype.getTopic = function () {
  return (
    /** @type{?proto.manabie.bob.Topic} */
    jspb.Message.getWrapperField(this, courses_pb.Topic, 1)
  );
};
/** @param {?proto.manabie.bob.Topic|undefined} value */


proto.manabie.bob.TopicOverdue.prototype.setTopic = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TopicOverdue.prototype.clearTopic = function () {
  this.setTopic(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TopicOverdue.prototype.hasTopic = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional google.protobuf.Timestamp due_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.TopicOverdue.prototype.getDueDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.TopicOverdue.prototype.setDueDate = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TopicOverdue.prototype.clearDueDate = function () {
  this.setDueDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TopicOverdue.prototype.hasDueDate = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional BasicProfile assigned_by = 3;
 * @return {?proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.TopicOverdue.prototype.getAssignedBy = function () {
  return (
    /** @type{?proto.manabie.bob.BasicProfile} */
    jspb.Message.getWrapperField(this, user_pb.BasicProfile, 3)
  );
};
/** @param {?proto.manabie.bob.BasicProfile|undefined} value */


proto.manabie.bob.TopicOverdue.prototype.setAssignedBy = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.TopicOverdue.prototype.clearAssignedBy = function () {
  this.setAssignedBy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.TopicOverdue.prototype.hasAssignedBy = function () {
  return jspb.Message.getField(this, 3) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveOverdueTopicRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveOverdueTopicRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveOverdueTopicRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveOverdueTopicRequest}
 */


proto.manabie.bob.RetrieveOverdueTopicRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveOverdueTopicRequest();
  return proto.manabie.bob.RetrieveOverdueTopicRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveOverdueTopicRequest}
 */


proto.manabie.bob.RetrieveOverdueTopicRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveOverdueTopicRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveOverdueTopicRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveOverdueTopicRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveOverdueTopicRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveOverdueTopicRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveOverdueTopicRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveOverdueTopicResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveOverdueTopicResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveOverdueTopicResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.TopicOverdue.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveOverdueTopicResponse}
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveOverdueTopicResponse();
  return proto.manabie.bob.RetrieveOverdueTopicResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveOverdueTopicResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveOverdueTopicResponse}
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.TopicOverdue();
        reader.readMessage(value, proto.manabie.bob.TopicOverdue.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveOverdueTopicResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveOverdueTopicResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.TopicOverdue.serializeBinaryToWriter);
  }
};
/**
 * repeated TopicOverdue topics = 1;
 * @return {!Array<!proto.manabie.bob.TopicOverdue>}
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.TopicOverdue>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.TopicOverdue, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.TopicOverdue>} value */


proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.TopicOverdue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.TopicOverdue}
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.TopicOverdue, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveOverdueTopicResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest();
  return proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setFrom(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f != null) {
    writer.writeMessage(2, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTo();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional google.protobuf.Timestamp from = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.getFrom = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.setFrom = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.clearFrom = function () {
  this.setFrom(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.hasFrom = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional google.protobuf.Timestamp to = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.getTo = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.setTo = function (value) {
  jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.clearTo = function () {
  this.setTo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesRequest.prototype.hasTo = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.repeatedFields_ = [1, 2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), courses_pb.Topic.toObject, includeInstance),
      topicsWithAssignByList: jspb.Message.toObjectList(msg.getTopicsWithAssignByList(), proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse();
  return proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.Topic();
        reader.readMessage(value, courses_pb.Topic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      case 2:
        var value = new proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy();
        reader.readMessage(value, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.deserializeBinaryFromReader);
        msg.addTopicsWithAssignBy(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, courses_pb.Topic.serializeBinaryToWriter);
  }

  f = message.getTopicsWithAssignByList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topics: (f = msg.getTopics()) && courses_pb.Topic.toObject(includeInstance, f),
      assignedBy: (f = msg.getAssignedBy()) && user_pb.BasicProfile.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy();
  return proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new courses_pb.Topic();
        reader.readMessage(value, courses_pb.Topic.deserializeBinaryFromReader);
        msg.setTopics(value);
        break;

      case 2:
        var value = new user_pb.BasicProfile();
        reader.readMessage(value, user_pb.BasicProfile.deserializeBinaryFromReader);
        msg.setAssignedBy(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopics();

  if (f != null) {
    writer.writeMessage(1, f, courses_pb.Topic.serializeBinaryToWriter);
  }

  f = message.getAssignedBy();

  if (f != null) {
    writer.writeMessage(2, f, user_pb.BasicProfile.serializeBinaryToWriter);
  }
};
/**
 * optional Topic topics = 1;
 * @return {?proto.manabie.bob.Topic}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.getTopics = function () {
  return (
    /** @type{?proto.manabie.bob.Topic} */
    jspb.Message.getWrapperField(this, courses_pb.Topic, 1)
  );
};
/** @param {?proto.manabie.bob.Topic|undefined} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.setTopics = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.clearTopics = function () {
  this.setTopics(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.hasTopics = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional BasicProfile assigned_by = 2;
 * @return {?proto.manabie.bob.BasicProfile}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.getAssignedBy = function () {
  return (
    /** @type{?proto.manabie.bob.BasicProfile} */
    jspb.Message.getWrapperField(this, user_pb.BasicProfile, 2)
  );
};
/** @param {?proto.manabie.bob.BasicProfile|undefined} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.setAssignedBy = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.clearAssignedBy = function () {
  this.setAssignedBy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy.prototype.hasAssignedBy = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * repeated Topic topics = 1;
 * @return {!Array<!proto.manabie.bob.Topic>}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Topic>} */
    jspb.Message.getRepeatedWrapperField(this, courses_pb.Topic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Topic>} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Topic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Topic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};
/**
 * repeated TopicWithAssignBy topics_with_assign_by = 2;
 * @return {!Array<!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy>}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.getTopicsWithAssignByList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy>} value */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.setTopicsWithAssignByList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy}
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.addTopicsWithAssignBy = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.TopicWithAssignBy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveCompletedTopicWeekliesResponse.prototype.clearTopicsWithAssignByList = function () {
  this.setTopicsWithAssignByList([]);
};

goog.object.extend(exports, proto.manabie.bob);